module.exports = __webpack_public_path__ + "img/folder.c2256105.svg";